//@author: mandy

import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { S25AddressComponent } from "./s25.address.component";

@NgModule({
    declarations: [S25AddressComponent],
    imports: [CommonModule, FormsModule],
    providers: [S25AddressComponent],
    exports: [S25AddressComponent],
})
export class S25AddressModule {
    constructor() {}
}
